import { Navigate } from "react-router-dom";
import { useSession } from "../context/SessionContext";
import { AppLayout } from "@/shared/components/Layout/AppLayout";

const AuthProtectedRoute = () => {
  const { session } = useSession();
  if (!session) {
    return <Navigate to="/login" replace />;
  }
  return <AppLayout />;
};

export default AuthProtectedRoute;
